export enum TransportMode {
  Car = 1,
  PublicTransport = 2,
  Bike = 3,
  Walking = 4,
}

export type LocationAddress = Readonly<{
  State: string | null;
  PostCode: string | null;
  StreetNumber: string | null;
  StreetName: string | null;
  SuburbName: string | null;
  Latitude: number | null;
  Longitude: number | null;
  AddressId?: string;
  UnitNumber?: string;
  FormattedAddress?: string;
  Description?: string | null;
  Selected?: boolean | null;
}>;

export type Origin = Readonly<{
  UserQueryDetailId: string;
  Address: LocationAddress;
  Minutes: number;
  HasSchools: boolean;
  HasTransports: boolean;
  HasSupermarkets: boolean;
  DomainUrl?: string;
  REAUrl?: string;
}>;

export interface LocationsData {
  UserQueryId?: string;
  calculateTime: boolean;
  Destination: LocationAddress | null;
  Minutes: number;
  TransportMode: TransportMode;
  Origins: Origin[];
  Selected: string | null;
}

export type LocationsState = Readonly<{
  data: LocationsData;
  status: 'idle' | 'pending' | 'succeeded' | 'rejected' | 'busy';
  error: string | null;
  calculateTime: boolean;
  isInitialLoad: boolean;
  isAddingOrigin: boolean;
}>;

export interface UpdateSettingsRequest {
  Minutes: number;
  TransportMode: TransportMode;
}
